import { Injectable } from '@angular/core';
import { HttpParameterCodec } from '@angular/common/http';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class PickcaseService {
    private apiSpringUrl = '/spring/pickcases';

    constructor(private http: HttpService) { }

    get(
        ownerId?: number
    ): Promise<any> {
        let url:string = '';
        if (ownerId !== undefined) {
            url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}?ownerId=${ownerId}`;
        } else {
            url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}`;
        }
        return this.http.get(url);
    }

    post(
        ownerId: number,
        pickcaseCd: string,
        pickcaseTx: string,
        volumeNr: number,
        capacityrateNr: number,
        updprogramCd: string
    ): Promise<any> {
        const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}`;
        const jsonInput = {
            ownerId: ownerId,
            pickcaseCd: pickcaseCd,
            pickcaseTx: pickcaseTx,
            volumeNr: volumeNr,
            capacityrateNr: capacityrateNr,
            updprogramCd: updprogramCd
        };
    return this.http.post(url, jsonInput);
    }

    put(
        pickcaseId: number,
        ownerId: number,
        pickcaseCd: string,
        pickcaseTx: string,
        volumeNr: number,
        capacityrateNr: number,
        updprogramCd: string,
        updcounterNr: number
    ): Promise<any> {
        const targetServiceCode = '';
        const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/${pickcaseId}`;
        const jsonInput = {
            pickcaseId: pickcaseId,
            ownerId: ownerId,
            pickcaseCd: pickcaseCd,
            pickcaseTx: pickcaseTx,
            volumeNr: volumeNr,
            capacityrateNr: capacityrateNr,
            updprogramCd: updprogramCd,
            updcounterNr: updcounterNr
        };
    return this.http.put(url, jsonInput, targetServiceCode);
    }

    delete(
        pickcaseId: number,
    ): Promise<any> {
        const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/${pickcaseId}`;
        return this.http.delete(url);
    }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/pickcase/pickcase.service.ts